import React from "react";
import Seo from "../components/Seo";

const PrivacyPolicy = () => {
  return (
    <>
      <Seo
        title="KK Solar Privacy Policy | Data Protection & User Rights"
        description="Read KK Solar's privacy policy for how we collect, use, and protect your data on our solar services website."
        url="https://kksolar.co.in/privacy-policy"
      />
      <div className="max-w-6xl mt-24 mx-auto text-start px-6 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">Last Updated: February 25, 2026</p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">1. Information We Collect</h2>
        <p>
          We may collect the following types of information:
        </p>
        <ul className="list-disc ml-6 mt-2">
          <li><strong>Personal Information:</strong> Name, email address, phone number, and other contact details.</li>
          <li><strong>Usage Data:</strong> Pages visited, time spent on the site, browser type, and device info.</li>
          <li><strong>Cookies and Tracking:</strong> We use cookies to enhance your experience.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">2. How We Use Your Information</h2>
        <ul className="list-disc ml-6">
          <li>Provide and improve our services.</li>
          <li>Process payments and fulfill orders.</li>
          <li>Send updates, promotions, and marketing communications.</li>
          <li>Respond to customer inquiries and support requests.</li>
          <li>Comply with legal obligations.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">3. Sharing Your Information</h2>
        <p>
          We do not sell your personal information. However, we may share it with:
        </p>
        <ul className="list-disc ml-6 mt-2">
          <li><strong>Service Providers:</strong> Payment processors, hosting, analytics, and trusted partners.</li>
          <li><strong>Legal Authorities:</strong> If required by law or for legal processes.</li>
          <li><strong>Business Transfers:</strong> In case of mergers, acquisitions, or sale of assets.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">4. Cookies and Tracking Technologies</h2>
        <p>
          We use cookies to remember preferences, analyze traffic, and provide personalized content.  
          You can disable cookies in your browser, but some features may not work.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">5. Data Security</h2>
        <p>
          We use industry-standard security measures to protect your data, but no method is 100% secure.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">6. Your Rights</h2>
        <ul className="list-disc ml-6">
          <li>Access, update, or delete your personal data.</li>
          <li>Opt-out of marketing communications.</li>
          <li>Request a copy of your data.</li>
          <li>Restrict or object to processing.</li>
        </ul>
        <p className="mt-2">
          Contact us at <a href="mailto:kksolarsolutions@gmail.com" className="text-blue-600 underline">kksolarsolutions@gmail.com</a> to exercise these rights.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">7. Third-Party Links</h2>
        <p>
          Our site may contain links to other websites. We are not responsible for their privacy practices.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">8. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Updates will be posted on this page with the revised date.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-3">9. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us at:
        </p>
        <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="font-bold text-lg text-blue-900">KK Solar</p>
          <p className="mt-2">
            <strong>Email:</strong> <a href="mailto:kksolarsolutions@gmail.com" className="text-blue-600 underline">kksolarsolutions@gmail.com</a><br />
            <strong>Phone:</strong> <a href="tel:+9195372279900" className="text-blue-600 underline">+91 95372 79900</a>
          </p>
          <p className="mt-2">
            <strong>Address:</strong><br />
            OPP MANAV CIRCLE NAGARPALIKA ROAD, 391/3,<br />
            TP-2, Anjar, Gujarat 370110<br />
            India
          </p>
          <p className="mt-2">
            <strong>Website:</strong> <a href="https://kksolar.co.in" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://kksolar.co.in</a><br />
            <strong>Privacy Policy URL:</strong> <a href="https://kksolar.co.in/privacy-policy" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://kksolar.co.in/privacy-policy</a>
          </p>
        </div>
      </section>
      
    
    </div>
    </>
  );
};

export default PrivacyPolicy;
